// Important! Do not edit this file - it is auto-generated by generate_emojis.sh
export const files = new Set([
    "1000.png",
    "10_10.png",
    "110.png",
    "50.png",
    "60fps_parrot.gif",
    "99.png",
    "ack.png",
    "acoustic-guitar.png",
    "alert.gif",
    "aww_thanksq.png",
    "bananadance.gif",
    "bandit.gif",
    "barcelona.png",
    "batman_yes.gif",
    "blinkingguy.gif",
    "blob-dance.gif",
    "blob-hype.gif",
    "blob-no.png",
    "blob-wave.gif",
    "blob-yes.png",
    "blob_aww.png",
    "blob_cozy.png",
    "blob_help.png",
    "blob_highfive.png",
    "blob_no_problem.png",
    "blob_smiley.png",
    "bluelightsaber.png",
    "bombastic-side-eye.png",
    "bongo_blob.gif",
    "bugs_bunny.png",
    "camping.gif",
    "cat-roomba-exceptionally-fast.gif",
    "cat_confused.png",
    "catjam.gif",
    "chefs-kiss.gif",
    "clapclap-e.gif",
    "clapping.gif",
    "coffin_dance.gif",
    "coldplay-kiss-cam.gif",
    "computerrage.gif",
    "conceit.png",
    "confused_dog.gif",
    "conga_parrot.gif",
    "cool-doge.gif",
    "cowboy-eyes.png",
    "cowboy-skull.png",
    "crycat.png",
    "crying-sunglasses-cowboy.png",
    "crying.gif",
    "dead.png",
    "deployparrot.gif",
    "devil.gif",
    "dino.gif",
    "done.png",
    "done_tick.png",
    "doraemon.png",
    "dumpster-fire.gif",
    "elmofire.gif",
    "emo.gif",
    "everythings_fine_parrot.gif",
    "evilgengarq.gif",
    "excellent.gif",
    "excuseme.gif",
    "extreme-teamwork.gif",
    "facepalm.png",
    "fc_barcelona.png",
    "fedex.png",
    "fingerheart.png",
    "fire.gif",
    "fistbump.gif",
    "flag-sicily.png",
    "friday_dog.gif",
    "frog-wow-scroll.gif",
    "fry_take_my_money.png",
    "ghost.gif",
    "google.png",
    "google_drive.png",
    "hatsunemiku.gif",
    "he_is_brighter.png",
    "headbanging_parrot.gif",
    "homerdisppear.gif",
    "huh.gif",
    "hyperfastparrot.gif",
    "icp_confetti.gif",
    "icp_glitch.gif",
    "icp_scan.gif",
    "icp_shatter.gif",
    "intellij_idea.png",
    "jira-new.png",
    "jul.png",
    "keanu_thanks.gif",
    "kekw.png",
    "ketchupq.png",
    "kirby_dance.gif",
    "kirby_jam.gif",
    "kittyjam.gif",
    "laser_hamish.png",
    "laser_julian.png",
    "let_me_in.gif",
    "lets-fucking-go.png",
    "lightsaber.png",
    "linkedin.png",
    "loading.gif",
    "lolsob.png",
    "mario_luigi_dance.gif",
    "mega-approved.gif",
    "meow_adorable.png",
    "meow_attention.gif",
    "meow_code.gif",
    "meow_coffee.png",
    "meow_coffeespitting.gif",
    "meow_heart.png",
    "meow_knife.png",
    "meow_noddies.gif",
    "meow_party.gif",
    "meow_popcorn.gif",
    "merged.png",
    "mic-drop.gif",
    "mild-panic-intensifies.gif",
    "minion.png",
    "money.gif",
    "mop.png",
    "mustard.png",
    "nervous-nelly.gif",
    "nodejs.png",
    "np.gif",
    "nyancat_big.gif",
    "oc_bloom.gif",
    "oc_blueprint.gif",
    "oc_cluster.gif",
    "oc_constellation.gif",
    "oc_crt.gif",
    "oc_cube.gif",
    "oc_fold.gif",
    "oc_greetings.gif",
    "oc_hover.gif",
    "oc_kaleidoscope.gif",
    "oc_mandala.gif",
    "oc_network.gif",
    "oc_orbit.gif",
    "oc_particles.gif",
    "oc_pillar.gif",
    "oc_propeller.gif",
    "oc_ribbon.gif",
    "oc_sparkle.gif",
    "oc_swirl.gif",
    "oc_target.gif",
    "oc_warp.gif",
    "oc_wireframe.gif",
    "old-man-yells-at-cloud.png",
    "open-eye-laughing.png",
    "papaya.png",
    "party-godzilla.gif",
    "party_blob.gif",
    "partyparrot.gif",
    "pigeondancing.gif",
    "pikachu.png",
    "pinched-fingers.gif",
    "pistachio.png",
    "playwright.png",
    "pokeball.png",
    "pornhub.png",
    "postman.png",
    "potato-chips.png",
    "quad_parrot.gif",
    "question_block.gif",
    "rage.png",
    "realmadrid.png",
    "redbull.png",
    "robber.png",
    "sadblob.gif",
    "sadge.png",
    "salute-hungergames.png",
    "salute-sob.png",
    "santa1q.gif",
    "scam.gif",
    "scary_squidward.png",
    "seahorse.png",
    "servicenow.png",
    "shaking-fist-dark-mode.gif",
    "side-eye.png",
    "sisyphus.png",
    "slack.png",
    "smart.gif",
    "sonic.gif",
    "southwest.png",
    "spidey-jinx.png",
    "star-trek-emoticon.gif",
    "star.gif",
    "star_trek.png",
    "starbucks.png",
    "stockrocket.gif",
    "stonks.png",
    "success.png",
    "superman.png",
    "surprised-pikachu.png",
    "tada_goth.png",
    "take_my_money.png",
    "terminator.png",
    "terraform-party.gif",
    "terraform.png",
    "thankyou.gif",
    "the_more_you_know.gif",
    "this_is_fine.gif",
    "troll.png",
    "tumbleweed.gif",
    "typingcat.gif",
    "uno-reverse.png",
    "vscode.png",
    "wait-wat.png",
    "wallstreetbets.png",
    "wide-eyed.png",
    "woohoo.png",
    "yay-frog.gif",
]);
